import React from 'react';

import SuppliersCreateForm from './SuppliersCreateForm';

import ModalHeader from 'CommonComponents/ModalHeader';

export default function SuppliersCreateModal({ supplierName = '', ...props }) {
    const close = () => {
        props.modalElement.hide();
    };

    return (
        <div id={props.modalId} ref={props.modalRef} tabIndex="-1" aria-hidden="true" className="hidden modal__box">
            <div className="modal__container">
                <div className="modal__inner-container">
                    <ModalHeader title={$t('Add supplier')} close={close}></ModalHeader>

                    <div className="tw-rounded-b">
                        <div className="modal__form-container">
                            <SuppliersCreateForm
                                suppliersIndexUrl={props.suppliersIndexUrl}
                                suppliersStoreUrl={props.suppliersStoreUrl}
                                suppliersCreateUrl={props.suppliersCreateUrl}
                                successHandler={props.successHandler}
                                supplierName={supplierName}
                                modal={true}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
